import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Kulleriga

  <span style="color:#85c1dc;">**FI:**</span>
  Kotiinkuljetuksella

  <span style="color:#85c1dc;">**RU:**</span>
  Курьером
*/
/* @__NO_SIDE_EFFECTS__ */
const m903 = msg(
  mf`Kulleriga`,
  mf`Kotiinkuljetuksella`,
  mf`Курьером`,
)

export { m903 as 'w.basket.delivery.home' }